import { render, staticRenderFns } from "./ShrimpSystem.vue?vue&type=template&id=95b03786&scoped=true&"
import script from "./ShrimpSystem.vue?vue&type=script&lang=js&"
export * from "./ShrimpSystem.vue?vue&type=script&lang=js&"
import style0 from "./ShrimpSystem.vue?vue&type=style&index=0&id=95b03786&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95b03786",
  null
  
)

export default component.exports